import { useAuthContext } from '../contexts/AuthContext';
import bluWaveLogo from '../assets/whiteBWLogo.png';

const Sidebar = () => {
  const { isAdmin } = useAuthContext();
  const isAdminPath = window.location.pathname.startsWith('/admin');

  return (
    <div className="w-[180px] min-h-screen bg-[#29446d] text-white fixed left-0 top-0 z-10 flex flex-col">
      <div className="px-4 pt-5 pb-6">
        <img
          src={bluWaveLogo}
          alt="BluWave Logo"
          className="w-[150px]"
          style={{ aspectRatio: '192.4/42', objectFit: 'contain' }}
        />
      </div>

      {isAdmin && (
        <nav className="px-3 flex-1">
          <a
            href="/admin/users"
            className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
              isAdminPath
                ? 'bg-white/20 text-white'
                : 'text-white/70 hover:bg-white/10 hover:text-white'
            }`}
          >
            Users
          </a>
        </nav>
      )}
    </div>
  );
};

export default Sidebar;
